import {
  NaccsDeclarationTypeEnum,
  NaccsDueDateExtensionTypeEnum,
  NaccsEvaluationEnum,
  NaccsImportRegulationCodeEnum,
  NaccsInsuranceTypeEnum,
  NaccsInvoiceTypeEnum,
  NaccsPaymentMethodEnum
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
import i18n from '@/plugins/i18n';

export function naccsDeclarationOptions(): SelectOption<string>[] {
  return [ // DO NOT REORDER
    NaccsDeclarationTypeEnum.C,
    NaccsDeclarationTypeEnum.F,
    NaccsDeclarationTypeEnum.Y,
    NaccsDeclarationTypeEnum.H,
    NaccsDeclarationTypeEnum.N,
    NaccsDeclarationTypeEnum.J,
    NaccsDeclarationTypeEnum.P,
    NaccsDeclarationTypeEnum.S,
    NaccsDeclarationTypeEnum.M,
    NaccsDeclarationTypeEnum.A,
    NaccsDeclarationTypeEnum.G,
    NaccsDeclarationTypeEnum.K,
    NaccsDeclarationTypeEnum.D,
    NaccsDeclarationTypeEnum.U,
    NaccsDeclarationTypeEnum.L,
    NaccsDeclarationTypeEnum.B,
    NaccsDeclarationTypeEnum.E,
    NaccsDeclarationTypeEnum.R
  ].map((val: NaccsDeclarationTypeEnum) => {
    return { value: val, label: i18n.t(`naccs.declaration-type.${val}`).toString() };
  });
}

export function naccsDueDateExtensionOptions(): SelectOption<string>[] {
  return [ // DO NOT REORDER
    NaccsDueDateExtensionTypeEnum.H,
    NaccsDueDateExtensionTypeEnum.K,
    NaccsDueDateExtensionTypeEnum.M,
    NaccsDueDateExtensionTypeEnum.A,
    NaccsDueDateExtensionTypeEnum.B,
    NaccsDueDateExtensionTypeEnum.C,
    NaccsDueDateExtensionTypeEnum.T,
    NaccsDueDateExtensionTypeEnum.E,
    NaccsDueDateExtensionTypeEnum.F
  ].map((val: NaccsDueDateExtensionTypeEnum) => {
    return { value: val, label: i18n.t(`naccs.due-date-extention-type.${val}`).toString() };
  });
}

export function naccsEvaluationOptions(): SelectOption<string>[] {
  return [ // DO NOT REORDER
    NaccsEvaluationEnum._0,
    NaccsEvaluationEnum._5,
    NaccsEvaluationEnum._6,
    NaccsEvaluationEnum._7,
    NaccsEvaluationEnum._Z
  ].map((val: NaccsEvaluationEnum) => {
    return { value: val, label: i18n.t(`naccs.evaluation.${val}`).toString() };
  });
}

export function naccsImportRegulationCodeOptions(): SelectOption<string>[] {
  return [
    NaccsImportRegulationCodeEnum.AC,
    NaccsImportRegulationCodeEnum.AD,
    NaccsImportRegulationCodeEnum.AM,
    NaccsImportRegulationCodeEnum.AN,
    NaccsImportRegulationCodeEnum.CA,
    NaccsImportRegulationCodeEnum.CR,
    NaccsImportRegulationCodeEnum.EX,
    NaccsImportRegulationCodeEnum.FD,
    NaccsImportRegulationCodeEnum.FL,
    NaccsImportRegulationCodeEnum.FM,
    NaccsImportRegulationCodeEnum.FR,
    NaccsImportRegulationCodeEnum.FS,
    NaccsImportRegulationCodeEnum.GA,
    NaccsImportRegulationCodeEnum.HU,
    NaccsImportRegulationCodeEnum.IA,
    NaccsImportRegulationCodeEnum.MA,
    NaccsImportRegulationCodeEnum.NA,
    NaccsImportRegulationCodeEnum.OP,
    NaccsImportRegulationCodeEnum.PA,
    NaccsImportRegulationCodeEnum.PD,
    NaccsImportRegulationCodeEnum.PE,
    NaccsImportRegulationCodeEnum.PL,
    NaccsImportRegulationCodeEnum.PM,
    NaccsImportRegulationCodeEnum.PS,
    NaccsImportRegulationCodeEnum.RA,
    NaccsImportRegulationCodeEnum.SH,
    NaccsImportRegulationCodeEnum.SP,
    NaccsImportRegulationCodeEnum.ST
  ].map((val: NaccsImportRegulationCodeEnum) => {
    return { value: val, label: i18n.t(`naccs.import-regulation-code.${val}`).toString() };
  });
}

export function naccsInsuranceOptions(): SelectOption<string>[] {
  return [
    NaccsInsuranceTypeEnum.A,
    NaccsInsuranceTypeEnum.B,
    NaccsInsuranceTypeEnum.C,
    NaccsInsuranceTypeEnum.D,
    NaccsInsuranceTypeEnum.E
  ].map((val: NaccsInsuranceTypeEnum) => {
    return { value: val, label: i18n.t(`naccs.insurance-type.${val}`).toString() };
  });
}

export function naccsInvoiceOptions(): SelectOption<string>[] {
  return [
    NaccsInvoiceTypeEnum.A,
    NaccsInvoiceTypeEnum.B,
    NaccsInvoiceTypeEnum.C,
    NaccsInvoiceTypeEnum.D
  ].map((val: NaccsInvoiceTypeEnum) => {
    return { value: val, label: i18n.t(`naccs.invoice-type.${val}`).toString() };
  });
}

export function naccsPaymentMethodOptions(): SelectOption<string>[] {
  return [
    NaccsPaymentMethodEnum.M,
    NaccsPaymentMethodEnum.R
  ].map((val: NaccsPaymentMethodEnum) => {
    return { value: val, label: i18n.t(`naccs.payment-method-type.${val}`).toString() };
  });
}

export function naccsTradingType1Options(): SelectOption<string>[] {
  return Array.from({ length: 5 }, (v, k) => k + 1).map((val: number) => {
    return { value: val.toString(), label: i18n.t(`naccs.trade-type.type-1.${val}`).toString() };
  });
}

export function naccsTradingType2Options(): SelectOption<string>[] {
  return Array.from(Array(10).keys()).map((val: number) => {
    return { value: val.toString(), label: i18n.t(`naccs.trade-type.type-2.${val}`).toString() };
  });
}

export function naccsTradingType3Options(): SelectOption<string>[] {
  return Array.from({ length: 8 }, (v, k) => k + 1).map((val: number) => {
    return { value: val.toString(), label: i18n.t(`naccs.trade-type.type-3.${val}`).toString() };
  });
}
